import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import HeroSlider from '../inc/HeroSlider';
import { FaWhatsapp } from "react-icons/fa6";
import Vmc from './inc/Vmc';
import UseSEO from "../../Hooks/useSEO";
import "../styles/Home.css";
import Servicescard from "../common/Services_card";
import BubbleBackground from "../common/BubbleBackground";
import usePauseOnOutOfView from "../../Hooks/usePauseOnOutOfView";



function Home() {
    // Use the hook at the top of the component suport in React 19
    UseSEO({
        title: "Sujaramaha Enterprises | Computer & Printers Sales & Services, CCTV,All types of Insurance, Water Filter / RO System & Kitchen Chimneys, Solar Water Heater, Inverter & Battery",
        description:
            "Sujaramaha Enterprises provides computer & Printers sales and services, All types of insurance assistance, CCTV installation, Water Filter / RO System & Kitchen Chimneys, Solar Water Heater, Inverter & Battery with trusted local support.",
        keywords:
            "computer sales and services, Printer sales and services, All types of insurance assistance, CCTV installation, Water Filter / RO System & Kitchen Chimneys, Solar Water Heater, Inverter & Battery, Sujaramaha Enterprises"
    });

    const sectionRef = usePauseOnOutOfView();

    return (

        <main id="home-page">

            <HeroSlider />
            {/* Our Company*/}
            <section ref={sectionRef} className="section">
                <BubbleBackground />
               <div className="container">
                    <div className="row">
                            <div className="col-md-12 text-center">
                            <h1 className="main-header">Our Company</h1>
                            <div className="underline mx-auto"></div>
                            <div className="ourcompany">
                                <strong>Sujaramaha Enterprises</strong> is a trusted one-stop service
                                provider offering Insurance Solutions, Computer & CCTV Services,
                                and Home & Energy Products under one roof.
                                We deliver comprehensive services ranging from Vehicle, Health, Travel,
                                and General Insurance to Computer Sales & Service, CCTV Installation,
                                Inverters, Batteries, Solar Water Heaters, Water Purifiers,
                                and Home Appliances. With a focus on honest guidance, reliable solutions,
                                and fast customer support,
                                    we are committed to meeting both personal and business needs.
                            </div>
                            <a href="/about">Read more<span className="screen-reader-text">Details</span></a>
                            
                        </div>
                    </div>
                        </div>
            </section>
            {/* Vision, Mission and Values*/}
            <Vmc />

            

                {/* ✅ SERVICES SECTION Services_hook */}
                <Servicescard />

                
            

            {/* WHATSAPP */}

            <a
                href="https://wa.me/919448344445"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with Sujaramaha Enterprises on WhatsApp"
            >
                <FaWhatsapp className="whatsapp-float" />
            </a>
            

        </main>
             
    )
}
export default Home;